
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo-login",
      function () {
        return require("private-next-pages/demo-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo-login"])
      });
    }
  